import React from "react";
import ReactPaginate from "react-paginate";

const Pagination = ({
  arrows = true,
  numeric = true,
  currentPage,
  totalPages,
  className,
  onPageChange,
}: PaginationProps) => {
  if (totalPages <= 1) {
    return null;
  }

  return (
    <div
      className={`pagination__container ${className} ${
        arrows ? "with-arrows" : ""
      } ${numeric ? "with-numeric" : ""}`}
    >
      <div className="wrapper clearfix">
        {arrows && (
          <div className="pagination__prev__container">
            <button
              className={`pagination__prev ${
                currentPage === 1 ? "hidden" : ""
              }`}
              onClick={() => onPageChange(currentPage - 1)}
              type="button"
            >
              « Previous page
            </button>
          </div>
        )}
        {numeric && (
          <div className="pagination__numeric clearfix">
            <ReactPaginate
              previousLabel=""
              nextLabel=""
              pageCount={totalPages}
              containerClassName="pagination"
              activeClassName="active"
              breakLabel={
                <button type="button" disabled>
                  ...
                </button>
              }
              onPageChange={({ selected }) => onPageChange(selected + 1)}
              forcePage={currentPage - 1}
              disableInitialCallback
              pageRangeDisplayed={3}
              marginPagesDisplayed={2}
            />
          </div>
        )}
        {arrows && (
          <div className="pagination__next__container">
            <button
              className={`pagination__next ${
                currentPage === totalPages ? "hidden" : ""
              }`}
              onClick={() => onPageChange(currentPage + 1)}
              type="button"
            >
              Next page »
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

interface PaginationProps {
  arrows?: boolean;
  numeric?: boolean;
  totalPages: number;
  currentPage: number;
  className?: string;
  onPageChange: (nextPage: number) => void;
}

export default Pagination;
